<template>
	<section class="section-container" v-if="!is_supplier">
		<div class="content-wrapper">

			<div class="content-heading" v-if="supplier.id">
				{{ $t('supplier.edit') }}
			</div>

			<div class="content-heading" v-else>
				{{ $t('supplier.add') }}
			</div>

			<div class="row">
				<div class="col-xl-4">
					<div class="card card-default">
						<div class="card-body">
							<form @submit.prevent="save" class="form-modal supplier">

								<div class="form-group">
									<label for="supplier__name">{{ $t('supplier.company') }} *</label>
									<input
											:class="{'parsley-error': errors.supplier__name}"
											autocomplete="off"
											class="form-control"
											id="supplier__name"
											:placeholder="$t('supplier.insert-company')"
											type="text"
											v-model="supplier.name">
									<ul class="parsley-errors-list filled" v-if="errors.supplier__name">
										<li class="parsley-required">{{ errors.supplier__name[0] }}</li>
									</ul>
								</div>

								<div class="form-group">
									<label for="supplier__registration_code">{{ $t('supplier.registration-code') }}
										*</label>
									<input
											:class="{'parsley-error': errors.supplier__registration_code}"
											autocomplete="off"
											class="form-control"
											id="supplier__registration_code"
											:placeholder="$t('supplier.insert-registration-code')"
											type="text"
											v-model="supplier.registration_code">
									<ul class="parsley-errors-list filled" v-if="errors.supplier__registration_code">
										<li class="parsley-required">{{ errors.supplier__registration_code[0] }}</li>
									</ul>
								</div>

								<div class="form-group">
									<label for="email">{{ $t('supplier.email') }} *</label>
									<input
											:class="{'parsley-error': errors.email}"
											autocomplete="off"
											class="form-control"
											id="email"
											:placeholder="$t('supplier.insert-email')"
											type="text"
											v-model="supplier.email">
									<ul class="parsley-errors-list filled" v-if="errors.email">
										<li class="parsley-required">{{ errors.email[0] }}</li>
									</ul>
								</div>

								<div class="form-group">
									<label>{{ $t('supplier.country')}}</label>
									<select class="custom-select custom-select-md mb-3" v-model="supplier.country_code">
										<option v-for="(country, idx) in countries" :key="idx" :value="country.code">
											{{country.name}}
										</option>
									</select>
								</div>

								<div class="form-group">

									<label>{{ $t('make.groups') }}*</label>

									<multiselect

											v-model="supplier.group"

											:tag-placeholder="$t('supplier.group-add-new')"

											:placeholder="$t('supplier.group-add-new')"

											label="name"

											track-by="name"

											:options="warehouse_groups"

											:multiple="true"

											:taggable="true"

											@tag="addGroup">

										<template slot="noOptions">{{ $t('global.no-options') }}</template>

									</multiselect>

									<ul class="parsley-errors-list filled" v-if="errors.groups">

										<li class="parsley-required">Palun vali osakond</li>

									</ul>

								</div>

								<div class="row pb-3">
									<div class="col-md-6">
										<div class="checkbox c-checkbox">
											<label for="is_active">
												<input
														v-model="supplier.is_active"
														:class="{'parsley-error': errors.is_active}"
														class="form-control"
														type="checkbox"
														id="is_active">
												<span class="fa fa-check"></span>{{ $t('supplier.active') }}
											</label>
										</div>
									</div>

									<div class="col-md-6" v-if="!this.supplier.id">
										<more/>
									</div>

								</div>
								<buttons url="suppliers"/>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import api from '@/api'
	import Buttons from '@/components/Buttons.vue'
	import message from '@/message'
	import More from '@/components/More.vue'
	import {parseApiError} from '@/utils'
	import Multiselect from 'vue-multiselect'

	const getData = (id, next) => {
		if (id) {
			Promise.all([
				api.get(`/suppliers/${id}/`),
				api.get(`/groups/?is_active=true&page_size=100`)
			])
				.then(([supplierUser, groups]) => {
					let group = []

					let groupsRegister = [];
					groups.data.results.forEach(g => {
						groupsRegister[g.name] = g.id;
					})

					if (supplierUser.data.warehouse_groups) {
						supplierUser.data.warehouse_groups.forEach(wg => {
							group.push({
								'id': groupsRegister[wg],
								'name': wg
							})
						})
					}
					supplierUser.data.group = group;

					api.patch(`/suppliers/${supplierUser.data.supplier__id}/`, {
						name: supplierUser.data.supplier__name,
						registration_code: supplierUser.data.supplier__registration_code,
						is_new: false,
					})
					next({
						supplier: supplierUser.data,
						warehouse_group: group,
						warehouse_groups: groups.data.results,
						groups: group,
					})
				})
		} else {
			Promise.all([
				api.get(`/groups/?is_active=true&page_size=100`)
			])
				.then(([groups]) => {
					next({
						warehouse_group: [],
						warehouse_groups: groups.data.results
					})
				})
		}
	}

	export default {
		components: {
			buttons: Buttons,
			more: More,
			Multiselect
		},
		data() {
			return {
				supplier: {
					name: null,
					registration_code: null,
					email: null,
					group: [],
					country: 0,
					active: true,
					country_code: 'EE'
				},
				warehouse_group: [],
				warehouse_groups: [],
				more: null,
				errors: {},
				groups: [],
				group: [],
				countries: [
					{name: 'Afghanistan', code: 'AF'},
					{name: 'Åland Islands', code: 'AX'},
					{name: 'Albania', code: 'AL'},
					{name: 'Algeria', code: 'DZ'},
					{name: 'American Samoa', code: 'AS'},
					{name: 'AndorrA', code: 'AD'},
					{name: 'Angola', code: 'AO'},
					{name: 'Anguilla', code: 'AI'},
					{name: 'Antarctica', code: 'AQ'},
					{name: 'Antigua and Barbuda', code: 'AG'},
					{name: 'Argentina', code: 'AR'},
					{name: 'Armenia', code: 'AM'},
					{name: 'Aruba', code: 'AW'},
					{name: 'Australia', code: 'AU'},
					{name: 'Austria', code: 'AT'},
					{name: 'Azerbaijan', code: 'AZ'},
					{name: 'Bahamas', code: 'BS'},
					{name: 'Bahrain', code: 'BH'},
					{name: 'Bangladesh', code: 'BD'},
					{name: 'Barbados', code: 'BB'},
					{name: 'Belarus', code: 'BY'},
					{name: 'Belgium', code: 'BE'},
					{name: 'Belize', code: 'BZ'},
					{name: 'Benin', code: 'BJ'},
					{name: 'Bermuda', code: 'BM'},
					{name: 'Bhutan', code: 'BT'},
					{name: 'Bolivia', code: 'BO'},
					{name: 'Bosnia and Herzegovina', code: 'BA'},
					{name: 'Botswana', code: 'BW'},
					{name: 'Bouvet Island', code: 'BV'},
					{name: 'Brazil', code: 'BR'},
					{name: 'British Indian Ocean Territory', code: 'IO'},
					{name: 'Brunei Darussalam', code: 'BN'},
					{name: 'Bulgaria', code: 'BG'},
					{name: 'Burkina Faso', code: 'BF'},
					{name: 'Burundi', code: 'BI'},
					{name: 'Cambodia', code: 'KH'},
					{name: 'Cameroon', code: 'CM'},
					{name: 'Canada', code: 'CA'},
					{name: 'Cape Verde', code: 'CV'},
					{name: 'Cayman Islands', code: 'KY'},
					{name: 'Central African Republic', code: 'CF'},
					{name: 'Chad', code: 'TD'},
					{name: 'Chile', code: 'CL'},
					{name: 'China', code: 'CN'},
					{name: 'Christmas Island', code: 'CX'},
					{name: 'Cocos (Keeling) Islands', code: 'CC'},
					{name: 'Colombia', code: 'CO'},
					{name: 'Comoros', code: 'KM'},
					{name: 'Congo', code: 'CG'},
					{name: 'Congo, The Democratic Republic of the', code: 'CD'},
					{name: 'Cook Islands', code: 'CK'},
					{name: 'Costa Rica', code: 'CR'},
					{name: 'Cote D\'Ivoire', code: 'CI'},
					{name: 'Croatia', code: 'HR'},
					{name: 'Cuba', code: 'CU'},
					{name: 'Cyprus', code: 'CY'},
					{name: 'Czech Republic', code: 'CZ'},
					{name: 'Denmark', code: 'DK'},
					{name: 'Djibouti', code: 'DJ'},
					{name: 'Dominica', code: 'DM'},
					{name: 'Dominican Republic', code: 'DO'},
					{name: 'Ecuador', code: 'EC'},
					{name: 'Egypt', code: 'EG'},
					{name: 'El Salvador', code: 'SV'},
					{name: 'Equatorial Guinea', code: 'GQ'},
					{name: 'Eritrea', code: 'ER'},
					{name: 'Estonia', code: 'EE'},
					{name: 'Ethiopia', code: 'ET'},
					{name: 'Falkland Islands (Malvinas)', code: 'FK'},
					{name: 'Faroe Islands', code: 'FO'},
					{name: 'Fiji', code: 'FJ'},
					{name: 'Finland', code: 'FI'},
					{name: 'France', code: 'FR'},
					{name: 'French Guiana', code: 'GF'},
					{name: 'French Polynesia', code: 'PF'},
					{name: 'French Southern Territories', code: 'TF'},
					{name: 'Gabon', code: 'GA'},
					{name: 'Gambia', code: 'GM'},
					{name: 'Georgia', code: 'GE'},
					{name: 'Germany', code: 'DE'},
					{name: 'Ghana', code: 'GH'},
					{name: 'Gibraltar', code: 'GI'},
					{name: 'Greece', code: 'GR'},
					{name: 'Greenland', code: 'GL'},
					{name: 'Grenada', code: 'GD'},
					{name: 'Guadeloupe', code: 'GP'},
					{name: 'Guam', code: 'GU'},
					{name: 'Guatemala', code: 'GT'},
					{name: 'Guernsey', code: 'GG'},
					{name: 'Guinea', code: 'GN'},
					{name: 'Guinea-Bissau', code: 'GW'},
					{name: 'Guyana', code: 'GY'},
					{name: 'Haiti', code: 'HT'},
					{name: 'Heard Island and Mcdonald Islands', code: 'HM'},
					{name: 'Holy See (Vatican City State)', code: 'VA'},
					{name: 'Honduras', code: 'HN'},
					{name: 'Hong Kong', code: 'HK'},
					{name: 'Hungary', code: 'HU'},
					{name: 'Iceland', code: 'IS'},
					{name: 'India', code: 'IN'},
					{name: 'Indonesia', code: 'ID'},
					{name: 'Iran, Islamic Republic Of', code: 'IR'},
					{name: 'Iraq', code: 'IQ'},
					{name: 'Ireland', code: 'IE'},
					{name: 'Isle of Man', code: 'IM'},
					{name: 'Israel', code: 'IL'},
					{name: 'Italy', code: 'IT'},
					{name: 'Jamaica', code: 'JM'},
					{name: 'Japan', code: 'JP'},
					{name: 'Jersey', code: 'JE'},
					{name: 'Jordan', code: 'JO'},
					{name: 'Kazakhstan', code: 'KZ'},
					{name: 'Kenya', code: 'KE'},
					{name: 'Kiribati', code: 'KI'},
					{name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
					{name: 'Korea, Republic of', code: 'KR'},
					{name: 'Kuwait', code: 'KW'},
					{name: 'Kyrgyzstan', code: 'KG'},
					{name: 'Lao People\'S Democratic Republic', code: 'LA'},
					{name: 'Latvia', code: 'LV'},
					{name: 'Lebanon', code: 'LB'},
					{name: 'Lesotho', code: 'LS'},
					{name: 'Liberia', code: 'LR'},
					{name: 'Libyan Arab Jamahiriya', code: 'LY'},
					{name: 'Liechtenstein', code: 'LI'},
					{name: 'Lithuania', code: 'LT'},
					{name: 'Luxembourg', code: 'LU'},
					{name: 'Macao', code: 'MO'},
					{name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
					{name: 'Madagascar', code: 'MG'},
					{name: 'Malawi', code: 'MW'},
					{name: 'Malaysia', code: 'MY'},
					{name: 'Maldives', code: 'MV'},
					{name: 'Mali', code: 'ML'},
					{name: 'Malta', code: 'MT'},
					{name: 'Marshall Islands', code: 'MH'},
					{name: 'Martinique', code: 'MQ'},
					{name: 'Mauritania', code: 'MR'},
					{name: 'Mauritius', code: 'MU'},
					{name: 'Mayotte', code: 'YT'},
					{name: 'Mexico', code: 'MX'},
					{name: 'Micronesia, Federated States of', code: 'FM'},
					{name: 'Moldova, Republic of', code: 'MD'},
					{name: 'Monaco', code: 'MC'},
					{name: 'Mongolia', code: 'MN'},
					{name: 'Montserrat', code: 'MS'},
					{name: 'Morocco', code: 'MA'},
					{name: 'Mozambique', code: 'MZ'},
					{name: 'Myanmar', code: 'MM'},
					{name: 'Namibia', code: 'NA'},
					{name: 'Nauru', code: 'NR'},
					{name: 'Nepal', code: 'NP'},
					{name: 'Netherlands', code: 'NL'},
					{name: 'Netherlands Antilles', code: 'AN'},
					{name: 'New Caledonia', code: 'NC'},
					{name: 'New Zealand', code: 'NZ'},
					{name: 'Nicaragua', code: 'NI'},
					{name: 'Niger', code: 'NE'},
					{name: 'Nigeria', code: 'NG'},
					{name: 'Niue', code: 'NU'},
					{name: 'Norfolk Island', code: 'NF'},
					{name: 'Northern Mariana Islands', code: 'MP'},
					{name: 'Norway', code: 'NO'},
					{name: 'Oman', code: 'OM'},
					{name: 'Pakistan', code: 'PK'},
					{name: 'Palau', code: 'PW'},
					{name: 'Palestinian Territory, Occupied', code: 'PS'},
					{name: 'Panama', code: 'PA'},
					{name: 'Papua New Guinea', code: 'PG'},
					{name: 'Paraguay', code: 'PY'},
					{name: 'Peru', code: 'PE'},
					{name: 'Philippines', code: 'PH'},
					{name: 'Pitcairn', code: 'PN'},
					{name: 'Poland', code: 'PL'},
					{name: 'Portugal', code: 'PT'},
					{name: 'Puerto Rico', code: 'PR'},
					{name: 'Qatar', code: 'QA'},
					{name: 'Reunion', code: 'RE'},
					{name: 'Romania', code: 'RO'},
					{name: 'Russian Federation', code: 'RU'},
					{name: 'RWANDA', code: 'RW'},
					{name: 'Saint Helena', code: 'SH'},
					{name: 'Saint Kitts and Nevis', code: 'KN'},
					{name: 'Saint Lucia', code: 'LC'},
					{name: 'Saint Pierre and Miquelon', code: 'PM'},
					{name: 'Saint Vincent and the Grenadines', code: 'VC'},
					{name: 'Samoa', code: 'WS'},
					{name: 'San Marino', code: 'SM'},
					{name: 'Sao Tome and Principe', code: 'ST'},
					{name: 'Saudi Arabia', code: 'SA'},
					{name: 'Senegal', code: 'SN'},
					{name: 'Serbia and Montenegro', code: 'CS'},
					{name: 'Seychelles', code: 'SC'},
					{name: 'Sierra Leone', code: 'SL'},
					{name: 'Singapore', code: 'SG'},
					{name: 'Slovakia', code: 'SK'},
					{name: 'Slovenia', code: 'SI'},
					{name: 'Solomon Islands', code: 'SB'},
					{name: 'Somalia', code: 'SO'},
					{name: 'South Africa', code: 'ZA'},
					{name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
					{name: 'Spain', code: 'ES'},
					{name: 'Sri Lanka', code: 'LK'},
					{name: 'Sudan', code: 'SD'},
					{name: 'Suriname', code: 'SR'},
					{name: 'Svalbard and Jan Mayen', code: 'SJ'},
					{name: 'Swaziland', code: 'SZ'},
					{name: 'Sweden', code: 'SE'},
					{name: 'Switzerland', code: 'CH'},
					{name: 'Syrian Arab Republic', code: 'SY'},
					{name: 'Taiwan, Province of China', code: 'TW'},
					{name: 'Tajikistan', code: 'TJ'},
					{name: 'Tanzania, United Republic of', code: 'TZ'},
					{name: 'Thailand', code: 'TH'},
					{name: 'Timor-Leste', code: 'TL'},
					{name: 'Togo', code: 'TG'},
					{name: 'Tokelau', code: 'TK'},
					{name: 'Tonga', code: 'TO'},
					{name: 'Trinidad and Tobago', code: 'TT'},
					{name: 'Tunisia', code: 'TN'},
					{name: 'Turkey', code: 'TR'},
					{name: 'Turkmenistan', code: 'TM'},
					{name: 'Turks and Caicos Islands', code: 'TC'},
					{name: 'Tuvalu', code: 'TV'},
					{name: 'Uganda', code: 'UG'},
					{name: 'Ukraine', code: 'UA'},
					{name: 'United Arab Emirates', code: 'AE'},
					{name: 'United Kingdom', code: 'GB'},
					{name: 'United States', code: 'US'},
					{name: 'United States Minor Outlying Islands', code: 'UM'},
					{name: 'Uruguay', code: 'UY'},
					{name: 'Uzbekistan', code: 'UZ'},
					{name: 'Vanuatu', code: 'VU'},
					{name: 'Venezuela', code: 'VE'},
					{name: 'Viet Nam', code: 'VN'},
					{name: 'Virgin Islands, British', code: 'VG'},
					{name: 'Virgin Islands, U.S.', code: 'VI'},
					{name: 'Wallis and Futuna', code: 'WF'},
					{name: 'Western Sahara', code: 'EH'},
					{name: 'Yemen', code: 'YE'},
					{name: 'Zambia', code: 'ZM'},
					{name: 'Zimbabwe', code: 'ZW'}
				]
			}
		},
		computed: {
			is_supplier() {
				return this.$store.getters.user_group === 'Supplier'
			}
		},
		mounted() {
			this.$parent.menu = 'setup'
			this.$parent.submenu = 'suppliers'
			this.$i18n.locale = this.$store.getters.language
		},
		methods: {
			is_user_able_to_change_view_proposals() {
				return this.$store.getters.user_group === 'Administrator' || this.$store.getters.user_group === 'Contractor'
			},
			save() {
				this.errors = {}
				let tagsGroups = []
				for (var n in this.warehouse_group) {
					tagsGroups.push(this.warehouse_group[n].name)
				}

				let supplierGroups = [];
				this.supplier.group.forEach(sG => {
					supplierGroups.push(sG.name);
				})

				const data = {
					is_employees_can_view_proposal: this.supplier.supplier__is_employees_can_view_proposal,
					name: this.supplier.name,
					registration_code: this.supplier.registration_code,
					email: this.supplier.email,
					country_code: this.supplier.country_code,
					is_active: this.supplier.is_active,
					warehouse_groups:supplierGroups
				}

				if (this.supplier.id) {
					api.patch(`/suppliers/${this.supplier.id}/`, data)
						.then(() => {
							message.success(this.$i18n.t('supplier.updated'))
							this.$router.push({name: 'suppliers'})
						})
						.catch(error => {
							let errors = parseApiError(error, this.$i18n)
							if (error.response && error.response.status === 400) {
								this.errors = errors
								if (!tagsGroups.length) {
									this.errors['warehouse_groups'] = [this.$i18n.t('one.group')]
								}
							} else {
								message.error(errors)
							}
						})
				} else {
					api.post('/suppliers/', data)
						.then((response) => {
							message.success(this.$i18n.t('supplier.added'))
							if (this.more) {
								this.supplier = {
									id: null,
									name: '',
									registration_code: '',
									is_employees_can_view_proposal: false,
									email: '',
									warehouse_groups: '',
									country_code: 0,
									is_active: true,
									supplier__is_active: true,
									supplier__name: '',
									supplier__registration_code: '',
									supplier__is_employees_can_view_proposal: false,
								}
								this.$router.push({name: 'supplier_add'})
							} else {
								this.$router.push({name: 'supplier_detail', params: {sup_id: response.data.id}})
							}
						})
						.catch(error => {
							let errors = parseApiError(error, this.$i18n)
							if (error.response && error.response.status === 400) {
								this.errors = errors
								if (!tagsGroups.length) {
									this.errors['warehouse_groups'] = [this.$i18n.t('one.group')]
								}
							} else {
								message.error(errors)
							}
						})
				}
			},
			addGroup(newName) {
				this.warehouse_group.push({
					name: newName
				})
			}
		},
		beforeRouteEnter(to, from, next) {
			getData(to.params.id, data => {
				next(vm => {
					Object.assign(vm.$data, data)
				})
			})
		},
		beforeRouteUpdate(to, from, next) {
			getData(to.params.id, data => {
				Object.assign(this.$data, data)
				next()
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/Supplier.vue